import { render } from "./contactComponent.vue?vue&type=template&id=9ff1ef94&scoped=true"
import script from "./contactComponent.vue?vue&type=script&lang=js"
export * from "./contactComponent.vue?vue&type=script&lang=js"

import "./contactComponent.vue?vue&type=style&index=0&id=9ff1ef94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff1ef94"]])

export default __exports__